import {
    useState, useMemo,
} from 'react'
import {
    RequestConfig,
} from 'app/types/request.types'
import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import {
    OperatingHours,
} from 'app/enums/label.enums'
import {
    WorkSchedule,
} from '../Gateways.types'
import getFields from './WorkSchedule.fields'
import useStyles from './WorkScheduleForm.style'

export default function WorkScheduleForm({
    requestParam,
    data,
    onSuccess,
    onCancel,
}: Readonly<{
    requestParam: RequestConfig,
    data: WorkSchedule,
    onSuccess: () => void,
    onCancel: () => void
}
>) {
    const [
        value,
        setValue,
    ] = useState<WorkSchedule>(data)
    const {
        classes,
    } = useStyles()

    const isAllDay = value.operatingHours === OperatingHours.ALL_DAY

    const getAllowedValues = useEnumValues()
    const fieldsWithClassName: [] = useFieldsWithClassName(
        getFields({
            getAllowedValues,
            isAllDay,
        }),
        classes,
    )

    const formValue = useMemo(() => {
        return {
            ...value,
            workStartsAt: isAllDay ? '00:00:00' : value.workStartsAt,
            workEndsAt: isAllDay ? '23:59:00' : value.workEndsAt,
        }
    }, [
        isAllDay,
        value,
    ])

    return (
        <FormWithControls
            name="Settings"
            requestParams={requestParam}
            value={formValue}
            fields={fieldsWithClassName}
            setExternalValue={setValue}
            onSuccess={onSuccess}
            onCancel={onCancel}
            classNames={{
                gridCardWrapper: classes.gridWrapper,
            }}
            exists
        />
    )
}
